import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Checkbox, Input, Button, notification } from 'antd';
import { Icon } from 'dlweb-components';
import styled from 'styled-components';

const DirectLink = (props) => {

  const [link, setLink] = useState('');
  const [preview, setPreview] = useState('');
  const buttonRef = useRef(null);

  const[, setClipboard] = useState(null);

  const togglePreview = (e) => {
    setPreview(e.target.checked === true ? '&preview=1' : '');
  }

  const toggleProtocol = (e) => {
    setLink(e.target.checked === true ? link.replace('http', 'dlweb') : link.replace('dlweb', 'http'));
  }

  useEffect(() => {
    setLink(props.directLink);
  }, [props.directLink])

  useEffect(() => {

    const Clipboard = require('clipboard');

    setClipboard(new Clipboard(ReactDOM.findDOMNode(buttonRef.current), {}));

    return () => {
      setClipboard(null);
    }
  }, [])

  return (
    <Container onClickCapture={props.onClickCapture}>
      <Input
        readOnly
        onClick={(e) => e.target.select()}
        value={link + preview}
        addonBefore={<Icon type="link" style={{fontSize: '12px'}}/>}
      />
      <CheckContainer>
        {!props.isFolder &&
          <Checkbox onChange={togglePreview}>Open preview</Checkbox>
        }
      </CheckContainer>
      <CheckContainer>
        <Checkbox onChange={toggleProtocol}>Open in WebTools Desktop</Checkbox>
      </CheckContainer>
      <Button
        type="primary"
        ref={buttonRef}
        onClick={() => notification.success({ message: 'Link copied to clipboard!' })}
        data-clipboard-text={link + preview}
      >
          <Icon type="clipboard" style={{marginRight: '10px'}} />
          Copy link to clipboard
        </Button>
      <Button onClick={props.hideModal} type="link" style={{float: 'right', padding: 0}}>Done</Button>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`

const CheckContainer = styled.div`
  padding-top: 10px;
  &:nth-child(3) {
    padding-bottom: 20px;
  }
`

const mapStateToProps = state => ({ toasts: state.toasts });

export default connect(mapStateToProps)(DirectLink);